var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62207 0.950195C5.74181 0.871584 5.9045 0.88497 6.00977 0.990234L6.0498 1.03906C6.12822 1.15872 6.11454 1.32031 6.00977 1.42578V1.42676L3.93555 3.5L6.00977 5.57324V5.57422L6.0498 5.62207C6.1172 5.72472 6.11746 5.85941 6.0498 5.96191L6.00977 6.00977C5.88922 6.12955 5.69357 6.13009 5.57324 6.00977L3.5 3.93555L1.42676 6.00977H1.42578C1.32029 6.11456 1.15768 6.12875 1.03809 6.0498L0.990234 6.00977C0.870451 5.88922 0.869909 5.69357 0.990234 5.57324L3.06348 3.5L0.990234 1.42676V1.42578C0.87049 1.30524 0.869922 1.11055 0.990234 0.990234L1.03906 0.950195C1.15878 0.871815 1.32159 0.885063 1.42676 0.990234L3.5 3.06348L5.57324 0.990234H5.57422L5.62207 0.950195Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.9bf69c5db57b0399d27ad1ca7391c3db.svg";
export { ForwardRef as ReactComponent };